package top.wcpe.allincore.ui.runtime.animation

import kotlin.jvm.JvmStatic

/**
 * 贝塞尔曲线 CPU 端工具：纯静态方法、无状态。
 *
 * 提供二次（quadratic）与三次（cubic）贝塞尔采样。
 * 多项式系数 2f / 3f 为贝塞尔展开的固有数值，整体豁免魔法值检查。
 */
@Suppress("MagicNumber")
object Bezier {

    /**
     * 二次贝塞尔曲线采样。
     *
     * @param p0 起点 [x, y]
     * @param p1 控制点 [x, y]
     * @param p2 终点 [x, y]
     * @param t  参数 0-1
     * @return [x, y]
     */
    @JvmStatic
    fun quadratic(p0: FloatArray, p1: FloatArray, p2: FloatArray, t: Float): FloatArray {
        val u = 1f - t
        val x = u * u * p0[0] + 2f * u * t * p1[0] + t * t * p2[0]
        val y = u * u * p0[1] + 2f * u * t * p1[1] + t * t * p2[1]
        return floatArrayOf(x, y)
    }

    /**
     * 三次贝塞尔曲线采样。
     *
     * @param p0 起点 [x, y]
     * @param p1 控制点 1 [x, y]
     * @param p2 控制点 2 [x, y]
     * @param p3 终点 [x, y]
     * @param t  参数 0-1
     * @return [x, y]
     */
    @JvmStatic
    fun cubic(p0: FloatArray, p1: FloatArray, p2: FloatArray, p3: FloatArray, t: Float): FloatArray {
        val u = 1f - t
        val uu = u * u
        val tt = t * t
        val x = uu * u * p0[0] + 3f * uu * t * p1[0] + 3f * u * tt * p2[0] + tt * t * p3[0]
        val y = uu * u * p0[1] + 3f * uu * t * p1[1] + 3f * u * tt * p2[1] + tt * t * p3[1]
        return floatArrayOf(x, y)
    }
}
